import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    handleError(error: unknown) {
        console.log(error);
    }
}

export const globalErrorHandler = {
    provide: ErrorHandler,
    useClass: GlobalErrorHandler,
};
